import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface EditorPicksProps {
  items: Movie[];
}

export default function EditorPicks({ items }: EditorPicksProps) {
  return (
    <section>
      <SectionHeading
        title="编辑精选"
        subtitle="编辑部反复挑选的值得一看的作品"
        moreTo="/category/tv"
        moreLabel="更多剧集"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {items.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}